var $ = require('jquery');
var Cookies = require("../vendor/js.cookie.min");

(function ($, window, document, undefined) {

    /*
     * DOCUMENT READY
     */

    $(document).ready(function () {


        if(localStorage.getItem("pins") === null){
            localStorage.setItem("pins", "[]");
        }

        $(document).on('click', '.backlink-custom', function(){
            window.history.back();
        });

        /* Manage header-search */
        $('#search-toggle').click(function() {
            $(this).toggleClass('open');
            $(this).closest('.searchbox').toggleClass('open');

            if ($(this).hasClass('open')) {
                $('#header-search').toggleClass('open');
                $('#tx-indexedsearch_header-searchbox-sword').focus();
            } else {
                $('#header-search').toggleClass('open');
            }
        });

        /* Manage Header-News */
        $('#header-news').each(function() {
            if ($(this).find('.news-header').html()) {
                var cookieName = 'Headernews-' + $('#header-news .news-header-item').attr('data-newsitem');
                var hasCookie = Cookies.get(cookieName);

                if (hasCookie != 1) {
                    $(this).addClass('open');
                    var paddingBottom = 75;
                    if ($(window).outerWidth() < 992) {
                        paddingBottom = 23;
                    }
                    var newsHeight = $(this).height() + paddingBottom;
                    var newPadding = newsHeight + $('.header-top-bar').height();
                    $(this).removeClass('open');
                    $(this).outerHeight(newsHeight);
                    $(this).addClass('open');
                    $('#main').css('padding-top', newPadding);

                    setTimeout(headerNewsScroll, 500);
                }
            }
        });

        $(window).resize(function() {
            $('#header-news').each(function() {
                if ($(this).hasClass('open')) {
                    $(this).removeAttr('style');
                    var paddingBottom = 75;
                    if ($(window).outerWidth() < 992) {
                        paddingBottom = 23;
                    }
                    var newsHeight = $(this).height() + paddingBottom;
                    var newPadding = newsHeight + $('.header-top-bar').height();
                    $(this).outerHeight(newsHeight);
                    $('#main').css('padding-top', newPadding);
                }
            });
        });

        $('.header-news-close').click(function() {
            $('#header-news').removeClass('open');
            $('#header').removeAttr('style');
            $('#main').addClass('animate-main');
            $('#main').removeAttr('style');
            setTimeout(function () {
                $('#main').removeClass('animate-main');
                $('#header').removeClass('scroll-header');
            }, 300);

            var cookieName = 'Headernews-' + $('#header-news .news-header-item').attr('data-newsitem');
            Cookies.set(cookieName, '1', { expires: 7 });
        });

        function headerNewsScroll() {
            if ($('#header-news').html() && $('#header-news').hasClass('open')) {
                var newsHeight = $('#header-news').outerHeight();

                if ($(document).scrollTop() < newsHeight) {
                    $('#header').removeAttr('style');
                    $('#header').addClass('scroll-header');
                } else {
                    $('#header').css('margin-top', (-1 * newsHeight));
                    $('#header').removeClass('scroll-header');
                }

                if ($(document).scrollTop() > (newsHeight + 150)) {
                    $('#header').addClass('shrink');
                } else {
                    $('#header').removeClass('shrink');
                }
            } else {
                if ($(document).scrollTop() > 150) {
                    $('#header').addClass('shrink');
                } else {
                    $('#header').removeClass('shrink');
                }
            }
        }

        $(window).scroll(function() {
            headerNewsScroll();
        });

        /* Check Treelevel for spacing between content and navigation */
        if ($('#main-navigation div.level2-menu').html()) {
            if ($('#main-navigation div.level2-menu').height() > 70) {
                $('body').addClass('hasLevel2NavLarge');
            } else {
                $('body').addClass('hasLevel2Nav');
            }
        }

        /* toggle footer-accordeon in mobile */
        $('#footer .gridColumn > .frame .frame-content > header').click(function() {
            $(this).closest('.frame').toggleClass('open');
        });

        /* size mobile-navigation for fixed header */
        $('#mobile-navigation .mobile-navigation-inner').each(function() {
            if ($(window).outerWidth() < 991.99) {
                $(this).css('max-height', $(window).outerHeight() - $('#header > .header-top-bar').outerHeight() - 31);
            }
        });

        $(window).resize(function() {
            $('#mobile-navigation .mobile-navigation-inner').each(function() {
                if ($(window).outerWidth() < 991.99) {
                    $(this).css('max-height', $(window).outerHeight() - $('#header > .header-top-bar').outerHeight() - 31);
                } else {
                    $(this).removeAttr('style');
                }
            });
        });

        /* toggle sub-levels in mobile-navigation */
        $('.menutoggler').click(function() {
            $(this).parent('li').toggleClass('open');

            if($(this).parent('li').hasClass('open')) {
                $(this).siblings('div.sublevel').slideDown(300);
            } else {
                $(this).siblings('div.sublevel').slideUp(300);
            }
        });

        /* toggle mobile-search/-navigation if the other one is clicked */
        $('.navigation-toggler').click(function() {
            if ($(this).hasClass('collapsed')) {
                $('.search-toggler:not(.collapsed)').click();
            }
        });

        $('.search-toggler').click(function() {
            if ($(this).hasClass('collapsed')) {
                $('.navigation-toggler:not(.collapsed)').click();
            }
        });

        /* select random images */
        $('.random-image-box').each(function() {
            var imageList = $(this).attr('data-images');
            var imageArray = imageList.split(',');

            var randomIndex = Math.floor((Math.random() * imageArray.length));

            $(this).find('img').attr('src', imageArray[randomIndex]);
        });

        /* select random images */
        $('.random-image-box-claim').each(function() {
            var imageList = $(this).attr('data-images');
            var imageArray = imageList.split(',');

            var claimList = $(this).attr('data-claim');
            var claimArray = claimList.split('|');

            var randomIndex = Math.floor((Math.random() * imageArray.length));

            $(this).find('img').attr('src', imageArray[randomIndex]);

            $(this).siblings('.introclaim-text').html(claimArray[randomIndex]);
        });

        /* manage filters for animalprotraits */
        $('.animalportraits-filter .btn-icon').click(function() {
            var filterId = $(this).attr('data-filter');

            if (filterId > 0) {
                $(this).siblings('[data-filter="0"]').removeClass('active');
                $(this).toggleClass('active');
            } else {
                $(this).siblings('.active').removeClass('active');
                $(this).addClass('active');
            }

            if (!$(this).siblings('.active').html() && !$(this).hasClass('active')) {
                $(this).siblings('[data-filter="0"]').addClass('active');
                filterId = 0;
            }

            if (filterId > 0) {
                $('.animalportraits-portraits .single-portrait').addClass('d-none');

                $(this).parent().find('.active').each(function() {
                    var buttonId = $(this).attr('data-filter');
                    $('.animalportraits-portraits .single-portrait[data-portrait="' + buttonId + '"]').removeClass('d-none');
                });
            } else {
                $('.animalportraits-portraits .single-portrait').removeClass('d-none');
            }
        });

        if (getUrlParameter('filterCategory')) {
            $('.animalportraits-filter .btn-icon[data-filter=' + getUrlParameter('filterCategory') + ']').click();
        }

        /* manage accordeons */
        $('.accordeonBox:not(.detailAccordeon) > .frame').each(function() {
            var elementId = 'accordeon_' + $(this).attr('id');
            var headerElement = $(this).find('header');
            var contentElement = $(this).find('.frame-content-inner');

            headerElement.attr('data-toggle', 'collapse').attr('data-target', '#' + elementId).attr('aria-expanded', 'false').attr('aria-controls', '#' + elementId).addClass('collapsed').addClass('initialized');
            contentElement.attr('id', elementId).addClass('collapse');

            if (contentElement.closest('.frame').hasClass('frame-type-textpic')) {
                headerElement.detach().insertBefore(contentElement);
            }

            if (headerElement.find('.element-subheader').html()) {
                headerElement.find('.element-subheader').detach().insertBefore(contentElement.find('*:first-child'));
            }
        });

        /* start sliders */
        $('.slideElement').slick({
            dots: false,
            pauseOnFocus: false,
            pauseOnHover: false,
            autoplay: false,
            autoplaySpeed: 5000,
        });

        $('.slideElementAuto').slick({
            dots: false,
            pauseOnFocus: false,
            pauseOnHover: false,
            autoplay: true,
            autoplaySpeed: 5000,
        });

        $('.imageSlideElement').each(function() {
            var slideElement = $(this);

            slideElement.slick({
                dots: false,
                pauseOnFocus: false,
                pauseOnHover: false,
                autoplay: false,
                autoplaySpeed: 5000,
            });

            if (slideElement.hasClass('multiImage')) {
                slideElement.append('<button class="slick-play slick-arrow" aria-label="Pause/Play" type="button">Pause/Play</button>');

                var pauseButton = slideElement.find('.slick-play');

                pauseButton.click(function () {
                    if (pauseButton.hasClass('slick-pause')) {
                        slideElement.slick('slickPause');
                        pauseButton.removeClass('slick-pause');
                    } else {
                        slideElement.slick('slickPlay');
                        pauseButton.addClass('slick-pause');
                    }
                });
            }
        });

        $('.imageSlideElementAuto').each(function() {
            var slideElement = $(this);

            slideElement.slick({
                dots: false,
                pauseOnFocus: false,
                pauseOnHover: false,
                autoplay: false,
                autoplaySpeed: 5000,
            });
            slideElement.slick('slickPlay');

            if (slideElement.hasClass('multiImage')) {
                slideElement.append('<button class="slick-play slick-pause slick-arrow" aria-label="Pause/Play" type="button">Pause/Play</button>');

                var pauseButton = slideElement.find('.slick-play');

                pauseButton.click(function () {
                    if (pauseButton.hasClass('slick-pause')) {
                        slideElement.slick('slickPause');
                        pauseButton.removeClass('slick-pause');
                    } else {
                        slideElement.slick('slickPlay');
                        pauseButton.addClass('slick-pause');
                    }
                });
            }
        });

        if($('form.validate-form').not('form.validate-form.sortenfinder-form').length > 0) {
            $('form.validate-form').parsley().on('field:validated', function() {
                var ok = $('.parsley-error').length === 0;
                $('.bs-callout-info').toggleClass('hidden', !ok);
                $('.bs-callout-warning').toggleClass('hidden', ok);
                if($('form.validate-form .parsley-error').length > 0) {
                  $('.required-info p').addClass('hasErrors');
                } else {
                  $('.required-info p').removeClass('hasErrors');
                }
            }).on('form:submit', function() {
                //return false; // Don't submit form for this demo
            });
        }

        $('.sponsorship-widget').each(function() {
            var widget = $(this);
            var widgetForm = widget.find('form');
            var url = widgetForm.attr('data-actionurl');

            widget.find('.widget-amount').click(function() {
                var newUrl = url + '?sponsorhip[amount]=' + $(this).attr('data-amount');
                widgetForm.get(0).action = newUrl;
            })

            widget.find('.widget-amount-free').click(function() {
                var newUrl = url + '?sponsorhip[amount]=' + $(this).val();
                widgetForm.get(0).action = newUrl;
            });
            widget.find('.widget-amount-free').on('input', function() {
                var newUrl = url + '?sponsorhip[amount]=' + $(this).val();
                widgetForm.get(0).action = newUrl;
            });
        });

        if ($('#patenschaft-amount').length) {
            $('#patenschaft-amount').val(getUrlParameter('sponsorhip[amount]'));
        }

        function getUrlParameter(name) {
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
            var results = regex.exec(location.search);
            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        }

        if ($('#sortebestellen').length) {
            var currentUserLabel = $('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentuserlabel') + ": " + $('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentuserid').split("_")[1];

            $('#sortebestellen-specie').val($('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-species'));
            $('#sortebestellen-user-id').val(currentUserLabel);
            $('#sortebestellen-firstname').val($('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentuserfirstname'));
            $('#sortebestellen-lastname').val($('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentuserlastname'));
            $('#sortebestellen-street').val($('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentuserstreet'));
            $('#sortebestellen-city').val($('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentusercity'));
            $('#sortebestellen-email').val($('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentusermail'));

            $('#sortebestellen-reciever').val($('.tx-psr-sortenfinder .detail-page.order-page p.order-address').attr('data-form-reciever'));
        }

        if ($('#sortebestellenfr').length) {
            var currentUserLabel = $('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentuserlabel') + ": " + $('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentuserid').split("_")[1];

            $('#sortebestellenfr-specie').val($('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-species'));
            $('#sortebestellenfr-user-id').val(currentUserLabel);
            $('#sortebestellenfr-firstname').val($('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentuserfirstname'));
            $('#sortebestellenfr-lastname').val($('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentuserlastname'));
            $('#sortebestellenfr-street').val($('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentuserstreet'));
            $('#sortebestellenfr-city').val($('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentusercity'));
            $('#sortebestellenfr-email').val($('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentusermail'));

            $('#sortebestellenfr-reciever').val($('.tx-psr-sortenfinder .detail-page.order-page p.order-address').attr('data-form-reciever'));
        }

        if ($('#sortebestellenit').length) {
            var currentUserLabel = $('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentuserlabel') + ": " + $('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentuserid').split("_")[1];

            $('#sortebestellenit-specie').val($('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-species'));
            $('#sortebestellenit-user-id').val(currentUserLabel);
            $('#sortebestellenit-firstname').val($('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentuserfirstname'));
            $('#sortebestellenit-lastname').val($('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentuserlastname'));
            $('#sortebestellenit-street').val($('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentuserstreet'));
            $('#sortebestellenit-city').val($('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentusercity'));
            $('#sortebestellenit-email').val($('.tx-psr-sortenfinder .detail-page.order-page').attr('data-form-currentusermail'));

            $('#sortebestellenit-reciever').val($('.tx-psr-sortenfinder .detail-page.order-page p.order-address').attr('data-form-reciever'));
        }

        if ($('.species-details').length) {
            var urlScrollMatch = window.location.search.match(/scrollTo=([^&]+)/)

            if (urlScrollMatch) {
                $('#detail_accordeon_order_header').click();

                $('html, body').animate({scrollTop: ($('#' + urlScrollMatch[1]).offset().top)}, 'fast');
            }
        }

        if ($('#detail_accordeon_form').length) {
            var eventformaccordeon = $('#detail_accordeon_form');
            var eventuid = eventformaccordeon.attr('data-form-uid');

            if ( $( "#eventform" ).length ) {
                var eventform = $('#eventform');
                var eventformaction = eventform.attr('action').split('?');

                //eventform.attr('action', eventformaction[0] + '?tx_psrevents_list[showUid]=' + eventuid + '&' + eventformaction[1]);
                eventform.attr('action', window.location.pathname + '?' + eventformaction[1]);
                $('#eventform-event').val(eventformaccordeon.attr('data-form-event'));
                $('#eventform-recipient').val(eventformaccordeon.attr('data-form-reciever'));
            }

            if ( $( "#eventanmeldungfranz" ).length ) {
                var eventform = $('#eventanmeldungfranz');
                var eventformaction = eventform.attr('action').split('?');

                //eventform.attr('action', eventformaction[0] + '?tx_psrevents_list[showUid]=' + eventuid + '&' + eventformaction[1]);
                eventform.attr('action', window.location.pathname + '?' + eventformaction[1]);
                $('#eventanmeldungfranz-event').val(eventformaccordeon.attr('data-form-event'));
                $('#eventanmeldungfranz-recipient').val(eventformaccordeon.attr('data-form-reciever'));
            }

            if ( $( "#eventanmeldungita" ).length ) {
                var eventform = $('#eventanmeldungita');
                var eventformaction = eventform.attr('action').split('?');

                //eventform.attr('action', eventformaction[0] + '?tx_psrevents_list[showUid]=' + eventuid + '&' + eventformaction[1]);
                eventform.attr('action', window.location.pathname + '?' + eventformaction[1]);
                $('#eventanmeldungita-event').val(eventformaccordeon.attr('data-form-event'));
                $('#eventanmeldungita-recipient').val(eventformaccordeon.attr('data-form-reciever'));
            }
            
        }

        $('.msnry-grid').each(function() {
            $(this).masonry({
               itemSelector: '.grid-item'
            });
        });

        $('input.o-qualitysealportal__button').click(function() {
            if($('#vignette_signs').length) {
              $('#vignette_signs').closest('.form-check').addClass('validate-checkbox');
            }
        })
    });

})(jQuery, window, document);
